/**
 * The publish marker — `.wb/publish.json`, committed with every publish.
 *
 * It says which builder produced the push (what it understands) and which
 * design system it rendered with, so the server can refuse a publish that
 * would silently get a site wrong: an editor from before custom design
 * systems re-rendering a custom-design-system site in Duro.
 */
import * as Schema from "effect/Schema";

export const PUBLISH_MARKER_PATH = ".wb/publish.json";

/**
 * What this builder understands, as a single rising number:
 *   1 — custom design systems (renders with the site's active one);
 *   2 — icon and inline widgets (an older editor drops them on publish);
 *   3 — inline-grid containers (an older editor omits them on publish).
 */
export const BUILDER_CAPABILITIES = 3;

export const PublishMarker = Schema.Struct({
  builderCapabilities: Schema.Int.pipe(Schema.nonNegative()),
  /** The design-system manifest the pages were rendered with; null = Duro. */
  designSystem: Schema.NullOr(Schema.String),
});
export type PublishMarker = Schema.Schema.Type<typeof PublishMarker>;
